<template>
  <div
    v-if="showPopup && announcements.length > 0"
    class="modal d-block"
    tabindex="-1"
    style="background-color: rgba(0, 0, 0, 0.5)"
    @click.self="closePopup"
  >
    <div class="modal-dialog modal-dialog-centered" style="max-width: 500px">
      <div class="modal-content">
        <div class="modal-header py-2">
          <h5 class="modal-title fw-bold">
            <i class="fa-solid fa-bullhorn me-2" style="color: blueviolet"></i>
            공지사항
          </h5>
          <button
            type="button"
            class="btn-close"
            @click="closePopup"
          ></button>
        </div>
        <div class="modal-body" style="max-height: 400px; overflow-y: auto">
          <div
            v-for="(item, index) in announcements"
            :key="item.id"
            class="mb-3"
            :class="{ 'border-bottom pb-3': index < announcements.length - 1 }"
          >
            <div class="d-flex align-items-center mb-1">
              <span
                class="badge me-2"
                :class="typeBadgeClass(item.type)"
              >
                {{ typeLabel(item.type) }}
              </span>
              <strong>{{ item.title }}</strong>
            </div>
            <div class="text-muted small" style="white-space: pre-line">
              {{ item.content }}
            </div>
            <div class="text-end text-muted" style="font-size: 0.75rem">
              {{ formatDate(item.created_at) }}
            </div>
          </div>
        </div>
        <div class="modal-footer py-2 d-flex justify-content-between">
          <button class="btn btn-sm btn-outline-secondary" @click="hideToday">
            오늘 하루 보지 않기
          </button>
          <button class="btn btn-sm btn-primary" @click="closePopup">
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = 'announcement_hide_date'

export default {
  name: 'AnnouncementPopup',
  data() {
    return {
      showPopup: false,
      announcements: []
    }
  },
  async mounted() {
    // 이미 로그인 상태면 바로 로드 (새로고침 시)
    if (this.$store.getters['user/isLogin']) {
      await this.loadAnnouncements()
    }
  },
  methods: {
    async loadAnnouncements() {
      // 오늘 하루 보지 않기 체크
      const hideDate = localStorage.getItem(STORAGE_KEY)
      const today = new Date().toISOString().split('T')[0]
      if (hideDate === today) {
        return
      }

      try {
        const result = await this.$get('/api/announcement')
        if (result.success && result.data && result.data.length > 0) {
          this.announcements = result.data
          this.showPopup = true
        }
      } catch (error) {
        console.error('공지사항 로드 실패:', error)
      }
    },
    closePopup() {
      this.showPopup = false
    },
    hideToday() {
      const today = new Date().toISOString().split('T')[0]
      localStorage.setItem(STORAGE_KEY, today)
      this.showPopup = false
    },
    typeBadgeClass(type) {
      switch (type) {
        case 'warning':
          return 'bg-warning text-dark'
        case 'update':
          return 'bg-info text-dark'
        default:
          return 'bg-primary'
      }
    },
    typeLabel(type) {
      switch (type) {
        case 'warning':
          return '중요'
        case 'update':
          return '업데이트'
        default:
          return '공지'
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}.${m}.${d}`
    }
  }
}
</script>
